import { QueryClient, QueryClientProvider } from 'react-query';
import {ReactQueryDevtools} from "react-query/devtools"
import { BrowserRouter as Router} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Home from './components/home/Home';
import ErrorBoundary from './components/routes/error/ErrorBoundary';
function App() {
const queryClient =new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
    <Router>
      <ToastContainer  />
        <div className="App">
              <Home/>
       </div>
   </Router>
    <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}
export default App;
